export default "__VITE_ASSET__dfb4f1e4__$_?component__"